import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

    const setEmailTemplates = (state, { payload }) => {
    state.emailTemplates=payload
    };
    const setEmailTemplateForm = (state, { payload }) => {
        state.emailTemplatesForm=payload
    };
    const clearEmailTemplates = (state, { payload })  => {
        return {...state,  emailTemplates:[] };
    };
    const clearEmailTemplateForm = (state, { payload })  => {
        return {...state,  emailTemplatesForm:{} };
    };
const initialState = {
  emailTemplates:[],
  emailTemplatesForm:{}
};

export default createReducer(initialState, {
  [TYPES.SET_EMAIL_TEMPLATES]: setEmailTemplates,
  [TYPES.SET_EMAIL_TEMPLATE_FORM]: setEmailTemplateForm,
  [TYPES.CLEAR_EMAIL_TEMPLATES]: clearEmailTemplates,
  [TYPES.CLEAR_EMAIL_TEMPLATE_FORM]:clearEmailTemplateForm
});
